
export function areDeepEqual<T>(a: T | undefined, b: T | undefined) {
	if (a == undefined && b == undefined) {
		return true;
	}
	if (a == undefined || b == undefined) {
		return false;
	}
	return JSON.stringify(a) === JSON.stringify(b);
}
